// src/components/Footer.js
import React from 'react';
import './HeaderFooter.css';

const Footer = () => {
  return (
    <footer className="custom-footer text-center  py-3">
      <small>Copyright Genus © {new Date().getFullYear()}</small>
    </footer>
  );
};

export default Footer;
